module.exports = __webpack_public_path__ + "img/ContentCreation.02a17ab6.jpg";